import { Link } from 'react-router-dom';

export const SIDEKICK_LOGO_SRC = '/sidekick-logo.png?v=20260910';

interface Props {
  /** When set, wraps the mark in a link. Omit on the login screen. */
  to?: string;
  size?: 'sm' | 'lg';
  title?: string;
}

export function BrandMark({ to, size = 'sm', title = 'Go to Board' }: Props) {
  const inner = (
    <>
      <img src={SIDEKICK_LOGO_SRC} alt="" className={`brand-logo brand-logo-${size}`} />
      <span className="brand-name">Sidekick</span>
    </>
  );
  if (to) {
    return (
      <Link to={to} className={`brand brand-link brand-${size}`} title={title}>
        {inner}
      </Link>
    );
  }
  const Tag = size === 'lg' ? 'h1' : 'div';
  return <Tag className={`brand brand-${size}`}>{inner}</Tag>;
}
